<template>
  <v-app>
    <v-main>
      <router-view />
      <LoadingApp />
    </v-main>
    <v-footer>
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} —
        <strong>Employee Suggestion System</strong>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>

<style scoped></style>
